import { render, staticRenderFns } from "./NotificationIndex.vue?vue&type=template&id=667315f0"
import script from "./NotificationIndex.vue?vue&type=script&lang=js"
export * from "./NotificationIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports